import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import { useNavigate, useLocation } from "react-router-dom";

import CustomModal from "../../components/CustomModal";
import Banner from "../../components/Banner";

import * as Material from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import api from "../../helpers/api.js";

import Config, { token } from "../../config.js";

import "./styles.css";

import { ReactComponent as MeasureIcon } from "../../assets/custom-icons/measuring-tape.svg";
import { ReactComponent as VerifiedIcon } from "../../assets/custom-icons/verify.svg";
import AddIcon from "@mui/icons-material/Add";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import TuneIcon from "@mui/icons-material/Tune";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import GroupsIcon from "@mui/icons-material/Groups";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import dayjs, { Dayjs } from "dayjs";

import networkGif from "../../assets/animations/network.gif";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";

import "react-image-crop/dist/ReactCrop.css";

import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Screen from "../../components/Screen";

import MainButton from "../../components/SmallComponents/MainButton";

import { useChallenge } from "../../contexts/ChallengeContext";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

import SearchIcon from "@mui/icons-material/Search";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

import { ChangeGroupModal } from "../Home";

export default function Groups() {
  const { currentChallenge, setLoading } = useChallenge();

  const [loadingGroups, setLoadingGroups] = useState(true);

  const [groups, setGroups] = useState([]);
  const [saving, setSaving] = useState(false);

  const [group_Update, setGroup_Update] = useState(null);
  const [group_Create, setGroup_Create] = useState(null);
  const [group_Delete, setGroup_Delete] = useState(null);
  const [group_Manage, setGroup_Manage] = useState(null);

  useEffect(() => {
    if (loadingGroups) {
      loadPageData();
    }
  }, [loadingGroups]);

  useEffect(() => {
    setLoadingGroups(true);
  }, [currentChallenge]);

  async function loadPageData() {
    try {
      const result = await api.get(
        "/challenge/groups?challenge_id=" + currentChallenge?.challenge_id
      );
      console.log("Groups", result.data);
      if (result.data) {
        setGroups([...result.data]);
      }
    } catch (e) {
      console.log(e);
    }

    setLoadingGroups(false);
  }
  async function handleSave() {
    setSaving(true);

    try {
      const result = await api.patch("/challenge/groups", {});
      console.log(result.data);
      if (result.data.success) {
        window.setSnackbar("Desafio salvo com sucesso");
        setLoading(true);
      }
    } catch (e) {
      console.error(e);
    }

    setSaving(false);
  }

  function handleOpenCreateGroupTool() {
    setGroup_Create(true);
  }
  function handleOpenManagerMembers(group) {
    setGroup_Manage({ ...group });
  }
  function handleOpenEdit(group) {
    setGroup_Update({ ...group });
  }
  function handleOpenDelete(group) {
    setGroup_Delete({ ...group });
  }

  return (
    <Screen title="Configurar grupos">
      <div className="groups-page-content pt-7">
        <div className="groups-header mb-2">
          <h3>Grupos criados</h3>
          <MainButton
            onClick={handleOpenCreateGroupTool}
            label="Criar novo grupo"
            color="primary"
            endIcon={<AddIcon />}
            shadow={false}
          />
        </div>

        {!loadingGroups &&
          groups.map((group, i) => (
            <Group
              key={i}
              info={group}
              handleOpenManagerMembers={handleOpenManagerMembers}
              handleOpenEdit={handleOpenEdit}
              handleOpenDelete={handleOpenDelete}
            />
          ))}
      </div>
      <EditModal
        open={!!group_Update}
        setOpen={() => setGroup_Update(null)}
        group={group_Update}
        onUpdated={() => setLoadingGroups(true)}
      />
      <CreateModal
        open={!!group_Create}
        setOpen={setGroup_Create}
        onCreated={() => setLoadingGroups(true)}
      />
      <DeleteModal
        open={!!group_Delete}
        setOpen={setGroup_Delete}
        onDeleted={() => setLoadingGroups(true)}
        group={group_Delete}
        groups={groups}
      />
      <ManagerMembersModal
        open={!!group_Manage}
        setOpen={(v) => {
          if (!v) setLoadingGroups(true);
          setGroup_Manage(v);
        }}
        group={group_Manage}
        groups={groups}
      />
    </Screen>
  );
}

const Group = ({
  info,
  handleOpenManagerMembers,
  handleOpenEdit,
  handleOpenDelete,
}) => {
  const { handleOpenGenerateLinkTool } = useChallenge();
  return (
    <div className="group-box mb-1 px-3 py-2">
      <h5>{info.name}</h5>
      <div className="group-info">
        <span>
          {info.members > 0 ? info.members : "nenhum"} membro
          {info.members > 1 && "s"}
        </span>
        <MainButton
          onClick={() => handleOpenManagerMembers(info)}
          label="Gerenciar participantes"
          color="white"
          endIcon={<GroupsIcon />}
          shadow={false}
        />
        <MainButton
          onClick={() => handleOpenGenerateLinkTool(info)}
          label="Gerar link"
          color="white"
          endIcon={<InsertLinkIcon />}
          shadow={false}
        />
        <Material.IconButton
          children={<DeleteIcon />}
          onClick={() => handleOpenDelete(info)}
        />
        <Material.IconButton
          children={<EditIcon />}
          onClick={() => handleOpenEdit(info)}
        />
      </div>
    </div>
  );
};

const EditModal = ({ open, setOpen, group, onUpdated }) => {
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState(group?.name);

  const { currentChallenge, handleLoadGroups } = useChallenge();

  useEffect(() => setName(group?.name), [open]);

  async function handleUpdateGroup() {
    if (name.length < 2) return;

    setLoading(true);

    try {
      const result = await api.patch("challenge/groups", {
        challenge_id: currentChallenge.challenge_id,
        name: name.trim(),
        group_id: group.id,
      });

      if (result.data.success) {
        window.setSnackbar("Grupo atualizado com sucesso");
        handleLoadGroups();
        onUpdated();
        setLoading(false);
        setOpen(false);
      }
    } catch (e) {
      window.setSnackbar("Houve um erro ao atualizar o grupo");
    }
  }

  return (
    <CustomModal
      maxWidth={450}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={loading}
      title={'Editar grupo "' + group?.name + '"'}
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bottomButtonSumbitText="Atualizar grupo"
      handleSubmit={handleUpdateGroup}
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container pt-2">
          <Material.TextField
            className={"counter-input fade delay-1"}
            disabled={loading}
            value={name}
            onInput={(e) => setName(e.target.value)}
            color="primary"
            label="Nome do grupo"
            InputLabelProps={{ shrink: true }}
            error={name?.length > 32}
            helperText={"" + (name?.length || 0) + "/32"}
            fullWidth
          />
        </div>
      }
      modalClass="group-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};

const CreateModal = ({ open, setOpen, onCreated, defaultName = "" }) => {
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState(defaultName);

  const { currentChallenge, handleLoadGroups } = useChallenge();

  useEffect(() => {
    setName(defaultName);
  }, [open]);

  async function handleCreateGroup() {
    if (name.length < 2) return;

    setLoading(true);

    try {
      const result = await api.post("challenge/groups", {
        challenge_id: currentChallenge.challenge_id,
        name: name.trim(),
      });

      if (result.data.success) {
        window.setSnackbar("Grupo criado com sucesso");
        setLoading(false);
        setOpen(false);
        handleLoadGroups();
        onCreated(result.data.group_id);
      }
    } catch (e) {
      window.setSnackbar("Houve um erro ao criar o grupo");
    }
  }

  return (
    <CustomModal
      maxWidth={450}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={loading}
      title={"Criar novo grupo"}
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bottomButtonSumbitText="Criar grupo"
      handleSubmit={handleCreateGroup}
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container pt-2">
          <Material.TextField
            className={"counter-input fade delay-1"}
            disabled={loading}
            value={name}
            onInput={(e) => setName(e.target.value)}
            color="primary"
            label="Nome do grupo"
            InputLabelProps={{ shrink: true }}
            error={name?.length > 32}
            helperText={"" + (name?.length || 0) + "/32"}
            fullWidth
          />
        </div>
      }
      modalClass="group-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};

const DeleteModal = ({ open, setOpen, onDeleted, group, groups }) => {
  const [loading, setLoading] = useState(false);

  const [destiny, setDestiny] = useState("-");

  const { currentChallenge, handleLoadGroups } = useChallenge();

  useEffect(() => setDestiny("-"), [open]);

  async function handleDeleteGroup() {
    setLoading(true);

    try {
      const formData = {
        challenge_id: currentChallenge.challenge_id,
        id: group.id,
      };

      if (destiny !== "-") {
        formData.new_group_id = destiny;
      }

      const result = await api.delete("challenge/groups", formData);

      if (result.data.success) {
        window.setSnackbar("Grupo removido com sucesso");
        handleLoadGroups();
        setLoading(false);
        setOpen(false);
        onDeleted();
      }
    } catch (e) {
      console.log(e);
      window.setSnackbar("Houve um erro ao remover o grupo");
    }
  }

  return (
    <CustomModal
      maxWidth={500}
      bottomButtonCancelText="Cancelar"
      hideSecondaryButton={false}
      loading={loading}
      title={'Apagar grupo "' + group?.name + '"'}
      handleSubmit={() => {}}
      open={open}
      handleClose={() => setOpen(false)}
      width="100%"
      bottomButtonSumbitText={
        destiny !== "-" ? "Apagar e realocar grupo" : "Apagar grupo"
      }
      mainButtonColor="error"
      handleSubmit={handleDeleteGroup}
      bodyWrapperStyle={{}}
      bodyComponent={
        <div className="container pt-2">
          {group?.members > 0 ? (
            <>
              <Material.Alert severity="warning">
                <b>Atenção:</b> ao apagar um grupo, todos os usuários serão
                desvinculados deste grupo.{" "}
                <b>Recomendamos que selecione um grupo de destino</b>
              </Material.Alert>
              <h4 className="mt-3 mb-1">Selecionar grupo de destino</h4>
              <Material.Select
                value={destiny}
                label="Age"
                fullWidth
                onChange={(e) => setDestiny(e.target.value)}
              >
                <Material.MenuItem value="-">
                  <em>Nenhum grupo selecionado</em>
                </Material.MenuItem>
                {groups
                  ?.filter((groupData) => groupData.id !== group?.id)
                  .map((group) => (
                    <Material.MenuItem value={group.id}>
                      {group.name}
                    </Material.MenuItem>
                  ))}
              </Material.Select>
              <Material.FormHelperText>
                Selecione um grupo de destino
              </Material.FormHelperText>
            </>
          ) : (
            <Material.Alert severity="warning">
              <b>Atenção:</b> Esta ação não poderá ser revertida
            </Material.Alert>
          )}
        </div>
      }
      modalClass="group-modal"
      bottomButtonsOrientation="vertical"
    />
  );
};

const ManagerMembersModal = ({ open, setOpen, group }) => {
  const [loading, setLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const [search, setSearch] = useState();

  const [users, setUsers] = useState([]);
  const REF_loadedUsers = useRef();

  const [selectedIds, setSelectedIds] = useState();

  const [changeGroupsOpen, setChangeGroupsOpen] = useState(false);

  const [confirmUnlink, setConfirmUnlink] = useState(false);

  const { currentChallenge } = useChallenge();

  useEffect(() => {
    loadUsers();
  }, [open]);

  async function handleRemoveUsers() {
    setLoadingUpdate(true);
    try {
      const result = await api.post("/challenge/groups/addMember", {
        challenge_id: currentChallenge?.challenge_id,
        member_ids: getMemberIdsWithUserIds(),
      });

      loadUsers();
      setConfirmUnlink(false);
      window.setSnackbar("Usuários removidos do grupo com sucesso");
    } catch (e) {
      console.log("1", e);
      window.setSnackbar(
        "Houve um erro ao carregar os usuários, por favor tente novamente mais tarde"
      );
    }
    setLoadingUpdate(false);
  }
  function handleRowSelected(v) {
    setSelectedIds([...v]);
  }
  function handleChangeGroup() {
    setChangeGroupsOpen(true);
  }
  function getMemberIdsWithUserIds() {
    return users
      .filter((user) => selectedIds.includes(user.id))
      .map((user) => user.member_id);
  }
  async function loadUsers() {
    try {
      const result = await api.get(
        "/challenge/members?challenge_id=" +
          currentChallenge?.challenge_id +
          "&group_id=" +
          group?.id
      );

      const data = result.data;

      REF_loadedUsers.current = [...data.users];

      setUsers([...data.users]);
    } catch (e) {
      console.log("2", e);

      window.setSnackbar(
        "Houve um erro ao carregar os usuários, por favor tente novamente mais tarde"
      );
    }
    setLoading(false);
  }

  return (
    <>
      <CustomModal
        maxWidth={450}
        bottomButtonCancelText="Concluir"
        hideSecondaryButton={false}
        loading={loading}
        title={"Gerenciar participantes"}
        open={open}
        handleClose={() => setOpen(false)}
        width="100%"
        bodyWrapperStyle={{}}
        bodyComponent={
          <>
            {confirmUnlink && (
              <div className="confirmation-overlay">
                <h4>
                  Atenção, você tem certeza de que deseja{" "}
                  <b>remover estes participantes deste grupo</b>?
                </h4>
                <h5 className="mt-1 mb-2">
                  Eles ainda terão acesso ao desafio, mas serão removidos deste
                  grupo
                </h5>
                <MainButton
                  onClick={handleRemoveUsers}
                  label="Remover participantes do grupo"
                  color="error"
                  endIcon={<DeleteIcon color="error" />}
                  shadow={false}
                  disabled={loadingUpdate}
                />
                <MainButton
                  onClick={() => setConfirmUnlink(false)}
                  label="Manter participantes"
                  color="white"
                  shadow={false}
                  className="mt-1"
                />
              </div>
            )}
            <div className="container">
              <div className="actions-bar">
                <MainButton
                  onClick={handleChangeGroup}
                  label="Trocar grupo"
                  color="white"
                  endIcon={<RestartAltIcon color="primary" />}
                  shadow={false}
                  disabled={selectedIds?.length === 0 || !selectedIds}
                  style={{ alignSelf: "flex-end" }}
                />
                <MainButton
                  onClick={() => setConfirmUnlink(true)}
                  label="Remover do grupo"
                  color="error"
                  endIcon={<DeleteIcon color="error" />}
                  shadow={false}
                  disabled={selectedIds?.length === 0 || !selectedIds}
                  style={{ alignSelf: "flex-end" }}
                />
              </div>

              <div className="modal-list-scrollable">
                {users && (
                  <DataGrid
                    style={{ height: "100%" }}
                    size="small"
                    autoHeight={true}
                    density="compact"
                    checkboxSelection
                    onSelectionModelChange={handleRowSelected}
                    selectionModel={selectedIds}
                    rows={users}
                    columns={[
                      {
                        field: "username",
                        headerName: "Nome",
                        flex: 2,
                      },
                    ]}
                    disableColumnMenu={true}
                    hideFooter={true}
                  />
                )}
              </div>
            </div>
          </>
        }
        modalClass="group-modal"
        bottomButtonsOrientation="vertical"
      />
      <ChangeGroupModal
        users={users.filter((user) => selectedIds?.includes(user.id))}
        open={changeGroupsOpen}
        setOpen={setChangeGroupsOpen}
        handleUpdated={() => loadUsers()}
      />
    </>
  );
};

export { CreateModal };
